/**
 * Reference Validation — re-exported from @lokascript/intent
 */

export { DEFAULT_REFERENCES, isValidReference } from '@lokascript/intent';
